import { generateAutomationName } from "app/pages/benchmark-tracker/helpers/helpers";

export const DOWNLOAD_PDF = generateAutomationName("report", ["button", "download", "pdf"]);
export const SUBSCRIPTIONS = generateAutomationName("report", ["button", "subscribe"]);
